import { motion } from "framer-motion"

const CTA_LINK = "https://pay.kiwify.com.br/EovX1uI"

export default function Hero() {
    return (
        <section id="hero" className="relative w-full flex flex-col items-center justify-center overflow-hidden bg-[#FDF0ED] bg-waves py-10 md:py-14">

            <div className="container mx-auto px-6 lg:px-16 relative z-10">
                <div className="flex flex-col items-center text-center">
                    <header className="mb-5 md:mb-[1.25vw]">
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <img
                                src="/assets/logo-cs.svg"
                                alt="Logotipo CS Fitness"
                                className="h-[48px] md:h-[3.9062vw] w-auto drop-shadow-sm"
                                width={150}
                                height={50}
                            />
                        </motion.div>
                    </header>

                    <motion.h1
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-[#140906] text-[20px] md:text-[1.7vw] font-semibold leading-snug tracking-tight max-w-[36ch] md:max-w-[48ch]"
                    >
                        Assista ao vídeo e conheça a plataforma feita para você, <strong className="text-[#E34626]">mulher</strong>, queimar gordura, emagrecer e{" "}
                        <strong className="text-[#E34626]">transformar o seu corpo.</strong>
                    </motion.h1>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="mt-7 md:mt-[1.8vw] w-full max-w-[700px] md:max-w-[45vw]"
                    >
                        <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-xl shadow-lg"
                                src="https://www.youtube.com/embed/NWWLPeeLRk4?si=PRcCHW9RZFXPdUXz"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    </motion.div>

                    <motion.a
                        href={CTA_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Começar treinamento CS Fitness agora"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="mt-8 md:mt-[2vw] relative group inline-block w-full md:w-auto"
                    >
                        <motion.div
                            animate={{
                                scale: [1, 1.05, 1],
                                boxShadow: [
                                    "0px 0px 0px rgba(227,70,38,0)",
                                    "0px 0px 40px rgba(227,70,38,0.6)",
                                    "0px 0px 0px rgba(227,70,38,0)",
                                ],
                            }}
                            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                            className="bg-[#E34626] hover:bg-[#c93a1e] rounded-full px-6 py-5 md:px-[2.6042vw] md:py-[1.25vw] transition-colors shadow-lg w-full"
                        >
                            <span className="text-white font-bold text-[14px] md:text-[0.9375vw] uppercase tracking-wider leading-tight block">
                                LIBERAR MEU ACESSO POR R$ 19,90
                            </span>
                        </motion.div>
                    </motion.a>
                </div>
            </div>
        </section>
    )
}
